import Model3d from "oc-modules/oc-jaco3d/arrangement3d/Model3d";
import Scenes from "oc-modules/oc-threejs/Scenes";
import Textures from "oc-modules/oc-threejs/Textures";
import { v3 } from "oc-threejs/short3";
import { App } from "../App";

export default class Interior3d extends Model3d {
    invalidColor = 0xff0000;
    validColor= 0x00ff00;

    constructor(jaco) {
        super(jaco);
        this.draggable = true;
        this.hoverable = true;
        this.tapable = true;
    }

    onTap(event) {
        this.jaco.onTap(event);
    }

    onDrop() {
        this.jaco.booth = this.jaco.positionValid ? APP.arrangement.booth : APP.arrangement.interiorSpace;
        APP.interactionHandler.decideAboutInteriorParent(this.jaco);
        this.hovering = false;
        this.onChangeInDragSelectHoverState();
    }

    transformObject3dAfterLoad(object, options) {
        super.transformObject3dAfterLoad(object, options);
        Scenes.filter(object, o => {
            if(o.material?.color) {
                o.material.originalColor = o.material.color;
            }
        })
    }

    onChangeInDragSelectHoverState() {
        if (this.dragging) {
            Textures.highlight(this, {
                opacity: STAGE.settings.dragDrop.dragOpacity,
                multiplyOpacity: true,
                color: this.jaco.positionValid ? this.validColor : this.invalidColor
            });
        } else if (this.hovering) {
            Textures.highlight(this, {
                color: 0x93b4ed,
            });
        } else if (this.selected) {
            Textures.highlight(this, {
                color: 0xeae693,
            });
        } else if(!this.jaco.positionValid) {
            Textures.highlight(this, {
                color: this.invalidColor
            });
        } else {
            Textures.unhighlight(this);
        }
        STAGE.dirty();
    }

    setCoverColor(color) {
        Scenes.filter(this.children[0], o => {
            if(o.material?.color) {
                o.material.color = color;
            }
        })
    }

    restoreColor() {
        Scenes.filter(this, o => {
            if(o.material?.originalColor) {
                o.material.color = o.material.originalColor;
            }
        })
    }

    onLoadModel() {
        super.onLoadModel();
        this.jaco.compileInteriorRestraints();
    }
}
